<!-- TEMPLATE -->
<template>
  <dean-dialog
          class="graph"
          title="Mobile offers"
          :icon="deanMobileIcon"
          align-top>
    <div class="">
      <line-chart :data="source"></line-chart>
    </div>
    <transition name="fade" mode="out-in" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </dean-dialog>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';

  // DEAN COMPONENTS
  import {
    plusIcon,
    deanMobileIcon,
    dashboardIcon,
    deanDialog,
    deanButton,
    deanLoadOverlay,
  } from '@deanone/dean-components';
  import Chartkick from 'vue-chartkick';
  import Chart from 'chart.js';
  import axios from 'axios';

  Vue.use(Chartkick.use(Chart));

  @Component({
    components: {
      deanLoadOverlay,
      Chartkick,
      Chart,
      plusIcon,
      deanMobileIcon,
      dashboardIcon,
      deanDialog,
      deanButton,
    },
  })

  export default class MobileOffersGraph extends Vue {
    public plusIcon: object = plusIcon;
    public deanMobileIcon: object = deanMobileIcon;
    public source: object = {};
    public isLoading: boolean = true;

    public mounted() {
      axios
        .post('/-/trade/api/widgets.mobileQuoteConceptsGraph')
        .then(({data}: any) => {
          this.source = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dialog :deep {
    padding: 0;
  }

  .dialog :deep(.dean-dialog-container) {
    width: 100%;
    height: 100%;
  }

  .dialog :deep(.dean-dialog-container .dean-dialog-content) {
    height: 100%;
  }
</style>
